<!--
 * @Author: liushumin
 * @Date: 2022-09-07 11:10:46
 * @LastEditTime: 2022-09-27 17:51:23
 * @LastEditors: liushumin
-->
<template>
  <el-main>
    <div class="top-wrap">
      <Bread></Bread>
      <div class="szPlace">
        <p class="szTitle">生资下单</p>
        <el-form
          :model="placeForm"
          :rules="rules"
          ref="placeForm"
          :inline="true"
          label-width="150px"
          class="place-form-add"
        >
          <div class="title">关联下单账号</div>
          <div class="Enter_message" style="margin-top: 20px">
            <div style="display: flex">
              <el-form-item label="搜索账号:" prop="systemType">
                <el-select
                  v-model="placeForm.systemType"
                  placeholder="用户类型"
                  style="width: 200px"
                  clearable
                  @clear="clearSelect"
                >
                  <el-option
                    v-for="item in systemTypeList"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="" prop="loginAccount">
                <el-input
                  style="width: 200px; margin-right: 10px"
                  v-model="placeForm.loginAccount"
                  placeholder="输入账号"
                  clearable
                  @clear="clearSelect"
                ></el-input>
                <el-button size="medium" type="primary" @click="queryAccount"
                  >搜索</el-button
                >
              </el-form-item>
            </div>
            <el-form-item
              label="登录账号:"
              class="w100"
              v-if="this.showAccountFlag == true"
            >
              <span v-if="accountInfo">{{ accountInfo.loginAccount }}</span>
            </el-form-item>
            <el-form-item
              label="类型:"
              class="w100"
              v-if="this.showAccountFlag == true"
            >
              <span v-if="accountInfo">{{
                accountInfo.systemType | filterSystem
              }}</span>
            </el-form-item>
            <el-form-item
              label="名称:"
              class="w100"
              v-if="this.showAccountFlag == true"
            >
              <span v-if="accountInfo">{{ accountInfo.systemName }}</span>
            </el-form-item>
          </div>
          <div class="title">添加商品</div>
          <div class="Enter_message" style="margin-top: 20px">
            <el-form-item label="搜索商品:" prop="name" class="w100">
              <!-- <el-input
                style="width: 200px; margin-right: 10px"
                v-model="placeForm.name"
                placeholder="输入商品名称"
              ></el-input
              > -->
              <el-autocomplete
                v-model="placeForm.name"
                clearable
                :fetch-suggestions="recordUidSelect"
                placeholder="请输入商品名称"
                :trigger-on-focus="false"
                ref="u_id"
                @select="
                  (item) => {
                    handleBrand(item, 'uid');
                  }
                "
                @clear="clearInput('u_id', 'uid')"
              ></el-autocomplete>
              <!-- <el-select
                v-model="value"
                placeholder="选择商品"
                style="width: 200px"
              >
                <el-option
                  v-for="item in options"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select> -->
            </el-form-item>
            <el-form-item
              label="商品名称:"
              class="w100"
              v-if="showGoodsFlag == true"
            >
              <span v-if="szInfo">{{ szInfo.productsName }}</span>
            </el-form-item>
            <el-form-item
              label="分类:"
              class="w100"
              v-if="showGoodsFlag == true"
            >
              <span v-if="szInfo"
                >{{ szInfo.oneName }}
                {{ szInfo.twoName != null ? szInfo.twoName + ">" : "" }}
                {{
                  szInfo.threeName != null ? szInfo.threeName + ">" : ""
                }}</span
              >
            </el-form-item>
            <el-form-item
              label="供应商:"
              class="w100"
              v-if="showGoodsFlag == true"
            >
              <span
                v-if="
                  szInfo &&
                  szInfo.enterpriseInfo &&
                  szInfo.enterpriseInfo.enterpriseName
                "
                >{{
                  szInfo.enterpriseInfo.enterpriseName &&
                  szInfo.enterpriseInfo.enterpriseName != null
                    ? szInfo.enterpriseInfo.enterpriseName
                    : ""
                }}</span
              >
            </el-form-item>
            <el-form-item
              label="属性:"
              class="w100"
              v-if="placeForm.name && showGoodsFlag == true"
              prop="goodsAttribute"
            >
              <div v-if="szInfo">
                <el-select
                  v-for="(itemSku, index) in szInfo.skuList"
                  :key="index"
                  v-model="itemSku.value"
                  :placeholder="itemSku.title"
                  ref="sel"
                  style="width: 200px; margin-right: 10px"
                  @change="changeSkuValue"
                >
                  <el-option
                    v-for="item in itemSku.list"
                    :key="item.specsValue"
                    :label="item.specsValue"
                    :value="item.specsValue"
                  >
                  </el-option>
                </el-select>
              </div>
            </el-form-item>
            <el-form-item
              label="单价:"
              class="w100"
              v-if="showGoodsFlag == true"
            >
              <el-input
                v-if="szInfo"
                style="width: 200px; margin-right: 10px"
                placeholder="单价"
                v-model="placeForm.productsPrice"
                @input="animateWidth"
              ></el-input>
            </el-form-item>
            <el-form-item
              label="供货方式:"
              class="w100"
              v-if="showGoodsFlag == true"
            >
              <span v-if="szInfo">{{ szInfo.modeOfSupply }}</span>
            </el-form-item>
            <el-form-item
              label="数量:"
              class="w100"
              prop="qty"
              v-if="showGoodsFlag == true"
            >
              <el-input
                style="width: 200px; margin-right: 10px"
                placeholder="请输入数量"
                v-model="placeForm.qty"
                @input="animateWidth"
              ></el-input>
            </el-form-item>
          </div>
          <div class="title" v-if="showGoodsFlag == true">添加费用</div>
          <div
            class="Enter_message"
            style="margin-top: 20px"
            v-if="showGoodsFlag == true"
          >
            <el-form-item label="商品合计:" prop="account" class="w100">
              <span> {{ totalShowPrice }}</span>
            </el-form-item>
            <el-form-item
              label="运费:"
              class="w100"
              prop="freightMoney"
              v-if="this.placeForm.qty"
            >
              <el-input
                style="width: 200px; margin-right: 10px"
                v-model="placeForm.freightMoney"
                placeholder="0.00"
                @input="countFare"
              ></el-input>
            </el-form-item>
            <el-form-item
              label="优惠金额:"
              class="w100"
              v-if="this.placeForm.qty"
            >
              <el-input
                style="width: 200px; margin-right: 10px"
                v-model="placeForm.treatPrice"
                placeholder="0.00"
                @input="getTreatPrice"
              ></el-input>
            </el-form-item>
            <el-form-item label="订单总金额:" class="w100">
              <span> {{ orderShowPrice }}</span>
            </el-form-item>
            <el-form-item label="应付金额:" class="w100">
              <span> {{ payShowPrice }}</span>
            </el-form-item>
          </div>
          <div
            style="display: flex; align-items: center"
            v-if="
              showAccountFlag == true && companyId != '' && companyId != null
            "
          >
            <div class="title" style="margin-right: 22px">收获地址</div>
            <!-- <span @click="addAddress" class="addressBtn"
              ><img
                src="../../../assets/szOrder/address_add_icon@2x.png"
                alt=""
              />添加地址</span
            > -->
            <span @click="selectAddress" class="addressBtn"
              ><img
                src="../../../assets/szOrder/address_change_icon@2x.png"
                alt=""
              />切换地址</span
            >
          </div>
          <div class="harvest-address" v-if="showAccountFlag == true">
            <p v-for="(item, index) in showSingleList" :key="index">
              <span>收货人：{{ item.fullname }}</span
              >&nbsp;&nbsp;&nbsp;&nbsp;
              <span>联系方式：{{ item.mobile_show }}</span
              >&nbsp;&nbsp;&nbsp;&nbsp;
              <span>收获地址：{{ item.address }}</span>
            </p>
            <!-- <div style="display: flex">
              <span class="editBtn"
                ><img
                  src="../../../assets/szOrder/icon_bianji@2x.png"
                  alt=""
                />修改</span
              >
              <span class="editBtn"
                ><img
                  src="../../../assets/szOrder/del_icon@2x.png"
                  alt=""
                />删除</span
              >
            </div> -->
          </div>
          <div class="title" v-if="false">支付方式</div>
          <div class="payment-box" v-if="false">
            <el-button>全额付款</el-button>
            <el-button>贷款分期</el-button>
          </div>
          <div class="title">发票信息</div>
          <div class="invoice-box" style="display: flex">
            <el-checkbox v-model="checked" @change="handleChange"
              >我需要开发票</el-checkbox
            >
            <span
              class="editBtn"
              style="margin-left: 10px"
              v-if="showFpBtn == true"
              @click="editFp"
              ><img
                src="../../../assets/szOrder/icon_bianji@2x.png"
                alt=""
              />添加发票</span
            >
          </div>
        </el-form>
        <div class="submit-footer">
          <!-- <el-button plain style="width: 100px" size="medium">取消</el-button> -->
          <el-button
            type="primary"
            size="medium"
            @click="submitOrder('placeForm')"
            >提交订单</el-button
          >
        </div>
      </div>
      <el-dialog
        :title="addressTitle"
        :visible.sync="dialogVisible_add"
        width="670px"
        :before-close="handleClose"
        class="szDialog"
      >
        <el-form
          :model="dynamicValAddForm"
          ref="dynamicValAddForm"
          class="demo-dynamic"
        >
          <el-row>
            <el-col :span="12">
              <el-form-item prop="name" label="姓名">
                <el-input
                  type="text"
                  placeholder="收货人姓名"
                  style="width: 60%"
                  v-model="dynamicValAddForm.name"
                  show-word-limit
                >
                </el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item prop="phone" label="手机号">
                <el-input
                  type="text"
                  placeholder="手机号码"
                  style="width: 60%"
                  v-model="dynamicValAddForm.phone"
                  show-word-limit
                >
                </el-input>
              </el-form-item>
            </el-col>
          </el-row>

          <el-form-item prop="area" label="所在地区">
            <el-select
              v-model="dynamicValAddForm.area"
              placeholder="所在地区"
              style="width: 80%"
            >
              <el-option
                v-for="item in options"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item prop="address" label="详细地址">
            <el-input
              type="textarea"
              :rows="3"
              style="width: 80%"
              placeholder="完善详细地址"
              v-model="dynamicValAddForm.address"
              show-word-limit
            >
            </el-input>
          </el-form-item>
          <div class="invoice-box" style="margin-left: 100px">
            <el-checkbox v-model="checked1">设置默认</el-checkbox>
          </div>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="dialogVisible_add = false">取 消</el-button>
          <el-button type="primary" @click="dialogVisible_add = false"
            >保存</el-button
          >
        </span>
      </el-dialog>
      <el-dialog
        title="选择收获地址"
        :visible.sync="dialogVisible_select"
        width="670px"
        :before-close="handleClose"
        class="szDialog"
      >
        <el-form class="select-dynamic">
          <div
            :class="
              cur == index
                ? 'select-dynamic-content select-dynamic-active'
                : 'select-dynamic-content'
            "
            v-for="(item, index) in selectAddressList"
            :key="index"
            @click="selectAddressCur(item, index)"
          >
            <p>
              <span
                ><span class="select-dynamic-label">收货人：</span
                >{{ item.fullname }}</span
              ><br />
              <span
                ><span class="select-dynamic-label">联系方式：</span
                >{{ item.mobile_show }}</span
              ><br />
              <span
                ><span class="select-dynamic-label">收获地址：</span
                >{{ item.address }}</span
              >
            </p>
          </div>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="dialogVisible_select = false">取 消</el-button>
          <el-button type="primary" @click="selectAddressInfo">确定</el-button>
        </span>
      </el-dialog>
      <!-- 修改发票信息弹框 -->
      <!-- @cancelStatus="getCancelStatus" -->
      <EditFare
        :openStatus="fareStatus"
        :infoFpObj="infoFp[0]"
        :orderId="orderId"
        @addSzFp="getAddSzFp"
        @closeStatus="getCloseStatus"
      ></EditFare>
    </div>
  </el-main>
</template>
<script>
import EditFare from "./OrderPop/EditFare.vue";
export default {
  data() {
    return {
      systemTypeList: [
        {
          value: "3",
          label: "合作社",
        },
        {
          value: "4",
          label: "村集体",
        },
      ],
      options: [
        {
          value: "选项1",
          label: "黄金糕",
        },
        {
          value: "选项2",
          label: "双皮奶",
        },
        {
          value: "选项3",
          label: "蚵仔煎",
        },
        {
          value: "选项4",
          label: "龙须面",
        },
        {
          value: "选项5",
          label: "北京烤鸭",
        },
      ],
      placeForm: {
        name: "",
        systemType: "",
        loginAccount: "",
        qty: "",
        freightMoney: "0.00",
        treatPrice: "0.00",
        goodsAttribute: "",
        productsPrice: "",
      },
      rules: {
        systemType: {
          required: true,
          message: "用户类型不能为空",
          trigger: "change",
        },
        loginAccount: {
          required: true,
          message: "账号不能为空",
          trigger: "blur",
        },
        name: {
          required: true,
          message: "搜索商品不能为空",
          trigger: "blur",
        },
        qty: {
          required: true,
          message: "数量不能为空",
          trigger: "blur",
        },
      },
      value: "",
      checked: false,
      checked1: false,
      dialogVisible_add: false,
      dialogVisible_select: false,
      dialogVisible_fp: false,
      dynamicValAddForm: {
        name: "",
        phone: "",
        area: "",
        address: "",
      },
      cur: -1,
      addressTitle: "",
      selectAddressList: [],
      contractForm: {
        u_id: "",
      },
      szInfo: {},
      accountInfo: {},
      enterpriseName: "",
      totalPrice: "",
      orderTotalPrice: "",
      payPrice: "",
      orderShowPrice: "",
      payShowPrice: "",
      totalShowPrice: "",
      showFpBtn: false,
      showAccountFlag: false,
      skuArr: [],
      addressSingle: {},
      showSingleList: [],
      fareStatus: "",
      infoFp: [
        {
          billTypes: "",
          billTitle: "",
          billInfo: "",
          payeeMsg: "",
        },
      ],
      orderId: "",
      showGoodsFlag: false,
      orderItemParam: {
        goodsAttribute: "",
        price: "",
        qty: "",
        totalPrice: "",
        goodsImg: "",
      },
      invoiceParam: {
        accountNum: "",
        address: "",
        bankName: "",
        billInfo: "",
        billTitle: "",
      },
      userId: "",
      invoiceParam: {},
      productsSpuId: "",
      userType: "",
      skuList: [],
      companyId: "",
    };
  },
  components: {
    EditFare,
  },
  filters: {
    filterSystem(val) {
      if (val == 3) {
        return "合作社";
      } else if (val == 4) {
        return "村集体";
      }
    },
  },
  mounted() {},
  methods: {
    // 选择属性
    changeSkuValue(val) {
      this.skuArr = this.skuList.map((item) => {
        return item.value;
      });
    },
    // 数量失去焦点
    animateWidth() {
      if (
        this.szInfo &&
        this.placeForm.productsPrice != null &&
        this.placeForm.qty != null
      ) {
        this.totalPrice = parseFloat(
          Number(this.placeForm.productsPrice) * Number(this.placeForm.qty)
        ).toFixed(2);
        this.totalShowPrice =
          "￥" +
          parseFloat(
            Number(this.placeForm.productsPrice) * Number(this.placeForm.qty)
          ).toFixed(2);
      } else {
        this.totalPrice = "";
        this.totalShowPrice = "";
      }
      this.countFare();
      this.getTreatPrice();
    },
    // 计算运费
    countFare() {
      if (this.totalPrice != "" && this.placeForm.freightMoney != null) {
        this.orderTotalPrice = parseFloat(
          Number(this.totalPrice) + Number(this.placeForm.freightMoney)
        ).toFixed(2);
        this.orderShowPrice =
          "￥" +
          parseFloat(
            Number(this.totalPrice) + Number(this.placeForm.freightMoney)
          ).toFixed(2);
      } else {
        this.orderTotalPrice = "";
        this.orderShowPrice = "";
      }
      this.getTreatPrice();
    },
    // 计算应付金额
    getTreatPrice() {
      if (this.placeForm.treatPrice != "" && this.orderTotalPrice != "") {
        this.payPrice = parseFloat(
          Number(this.orderTotalPrice) - Number(this.placeForm.treatPrice)
        ).toFixed(2);
        this.payShowPrice =
          "￥" +
          parseFloat(
            Number(this.orderTotalPrice) - Number(this.placeForm.treatPrice)
          ).toFixed(2);
      } else {
        this.payPrice = parseFloat(Number(this.orderTotalPrice)).toFixed(2);
        this.payShowPrice =
          "￥" + parseFloat(Number(this.orderTotalPrice)).toFixed(2);
      }
    },
    // 查看地址列表
    getAddress() {
      let paramsAddress = {
        companyId: this.accountInfo.companyId,
      };
      this.$http.szOrder.getAddressPaginator(paramsAddress).then((res) => {
        this.selectAddressList = res.data.content;
        this.showSingleList = this.selectAddressList.filter((item) => {
          return item.default == 10;
        });
        console.log(this);
      });
    },
    // 查询账号
    queryAccount() {
      if (this.placeForm.systemType && this.placeForm.loginAccount) {
        this.$http.szOrder
          .getAccountInfo(
            {},
            Number(this.placeForm.systemType),
            this.placeForm.loginAccount
          )
          .then((res) => {
            this.accountInfo = res.data;
            this.showAccountFlag = true;
            this.userId = this.accountInfo.id;
            this.companyId = this.accountInfo.companyId;
            let sysType = this.accountInfo.systemType;
            this.enterpriseName = this.accountInfo.systemName;
            if (sysType == "3") {
              this.userType = "合作社";
            } else {
              this.userType = "村集体";
            }
            if (this.companyId != null) {
              this.getAddress();
            }
          });
      }
    },
    // 模糊查询搜索商品
    recordUidSelect(queryString, callback) {
      this.$refs.u_id.activated = true || this.$refs.u_id.handleFocus();
      let result = [];
      var params = {
        name: queryString,
      };
      if (queryString == "") {
        callback(result);
      } else {
        this.$http.szOrder.getListByName(params).then((res) => {
          if (res.status == 1) {
            let data = res.data;
            for (let i of data) {
              result.push({
                id: i.id,
                value: i.productsName,
              });
            }
            callback(result);
          }
        });
      }
    },
    // 点击商品调商品详情接口
    handleBrand(item, key) {
      this.productsSpuId = item.id;
      this.contractForm[key] = item.id;

      this.$http.szOrder
        .getInfo({
          id: item.id,
        })
        .then((res) => {
          if (res.status == 1) {
            this.szInfo = res.data;
            this.skuList = this.szInfo.skuList;
            this.showGoodsFlag = true;
            this.placeForm.productsPrice = this.szInfo.productsPrice;
            this.placeForm.goodsImg =
              this.szInfo.imgList != null && this.szInfo.imgList.length > 0
                ? this.szInfo.imgList[0].imgUrl
                : "";
          }
        });
    },
    // 清空输入商品事件
    clearInput() {
      this.showGoodsFlag = false;
    },
    // 清空账号信息
    clearSelect() {
      this.showAccountFlag = false;
    },
    addAddress() {
      this.dialogVisible_add = true;
      this.addressTitle = "添加收获地址";
    },
    handleEdit() {
      this.dialogVisible_add = true;
      this.addressTitle = "编辑收获地址";
    },
    selectAddress() {
      this.dialogVisible_select = true;
    },
    handleClose() {
      this.dialogVisible_add = false;
      this.dialogVisible_select = false;
      this.dialogVisible_fp = false;
    },
    selectAddressCur(val, ind) {
      this.addressSingle = val;
      this.cur = ind;
    },
    selectFpRadio(val) {
      this.dynamicValFpForm.fpRadio = val;
    },
    selectTRadio(val) {
      this.dynamicValFpForm.tRadio = val;
    },
    handleChange(val) {
      this.checked = val;
      if (this.checked == true) {
        this.showFpBtn = true;
      } else {
        this.showFpBtn = false;
      }
    },
    // 添加发票
    editFp() {
      this.fareStatus = true;
    },
    selectAddressInfo() {
      this.showSingleList[0] = this.addressSingle;
      this.dialogVisible_select = false;
    },
    getCloseStatus(val) {
      if (val == true) {
        this.fareStatus = false;
      }
    },
    // 获取发票信息
    getAddSzFp(val) {
      this.invoiceParam = val;
    },
    // 提交生资下单
    submitOrder(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let freightMoney = "",
            remitMoneyPrice = "",
            discountPrices = "",
            orderItemParam = {
              goodsAttribute:
                this.skuArr.length > 0 ? this.skuArr.join(",") : "",
              price: this.placeForm.productsPrice,
              qty: this.placeForm.qty,
              totalPrice: this.totalPrice,
            },
            shippingAddressInfo = {
              addr: "",
              receiver: "",
              telphone: "",
            };

          if (
            this.placeForm.systemType != "" &&
            this.placeForm.loginAccount != "" &&
            this.showAccountFlag == true
          ) {
            if (this.showSingleList.length > 0) {
              shippingAddressInfo.addr = this.showSingleList[0].address;
              shippingAddressInfo.receiver = this.showSingleList[0].fullname;
              shippingAddressInfo.telphone = this.showSingleList[0].mobile_show;
            }
            this.userId = this.userId;
          }

          if (this.placeForm.name != "" && this.showGoodsFlag == true) {
            orderItemParam = {
              goodsAttribute:
                this.skuArr.length > 0 ? this.skuArr.join(",") : "",
              price: this.placeForm.productsPrice,
              qty: this.placeForm.qty,
              totalPrice: this.totalPrice,
              productsSpuId: this.productsSpuId,
              goodsImg: this.placeForm.goodsImg,
            };
            freightMoney = this.placeForm.freightMoney;
            remitMoneyPrice = this.payPrice;
            discountPrices = this.placeForm.treatPrice;
          }

          if (this.checked == true) {
            this.invoiceParam = this.invoiceParam;
            console.log(this.invoiceParam);
          }

          let orderParams = {
            freightMoney: freightMoney,
            discountPrices: discountPrices,
            remitMoneyPrice: remitMoneyPrice,
            orderItemParam: orderItemParam,
            invoiceParam: this.invoiceParam,
            shippingAddressInfo: shippingAddressInfo,
            userId: this.userId,
            userType: this.userType,
            enterpriseName: this.enterpriseName,
            type: 1,
          };
          this.$http.szOrder.addOrderInfo(orderParams).then((res) => {
            if (res.status == 1) {
              this.$message({
                message: "提交成功",
                type: "success",
              });
              let path = "/szoperation/order/placeSuccess";
              this.$router.push({
                path,
              });
            }
          });
        } else {
          return false;
        }
      });
    },
  },
};
</script>
<style lang="scss" scoped>
@import "../../../styles/order-global.scss";
.harvest-address {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 80%;
  background: #f2f8f8;
  padding: 5px 10px;
  margin: 8px 0;
}
.harvest-address-info span {
  line-height: 28px;
}
.submit-footer {
  text-align: center;
  padding: 20px 0;
}
::v-deep .el-descriptions :not(.is-bordered) .el-descriptions-item__cell {
  width: 30px !important;
}
.title {
  margin: 10px 0 10px 0;
  font-size: 18px;
  color: #333333;
  display: flex;
  align-items: center;
  font-weight: bold;

  label {
    font-size: 16px;
    color: #999999;
  }

  &:before {
    content: "";
    display: inline-block;
    width: 5px;
    height: 18px;
    background: #018388;
    border-radius: 3px;
    margin-right: 5px;
  }
}

.el-form-item {
  position: relative;
  margin-bottom: 8px !important;
  .el-input,
  .el-select,
  .el-cascader {
    width: 300px;
  }
  &.w100 {
    width: 100%;
  }
}

.select-dynamic .select-dynamic-content {
  width: 92%;
  background: #ffffff;
  border: 1px solid #dfe7eb;
  border-radius: 3px;
  margin-bottom: 20px;
  line-height: 35px;
  padding: 10px 25px;
  color: #333333;
  font-size: 16px;
  cursor: pointer;
}
.select-dynamic .select-dynamic-active {
  background: #f2fbfb !important;
  border: 1px solid #018388 !important;
}
.select-dynamic-label {
  width: 100px;
  text-align: right;
  color: #666666;
}
.addressBtn {
  width: 112px;
  height: 32px;
  background: #018388;
  border-radius: 4px;
  font-size: 16px;
  font-weight: 400;
  color: #ffffff;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-right: 9px;
  cursor: pointer;
}
.editBtn {
  font-size: 16px;
  font-weight: 400;
  color: #018388;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  margin-right: 9px;
}
.editBtn img {
  width: 18px;
  height: 18px;
  display: inline-block;
  margin-right: 4px;
}
.addressBtn img {
  width: 18px;
  height: 18px;
  display: inline-block;
  margin-right: 4px;
}
</style>
